import * as types from "./types";

import {
    getPurchaseOrderListAxios,
    deletePurchaseOrdersAxios,
    postPurchaseOrdersAxios,
    putPurchaseOrdersAxios,
    getPurchaseOrdersByIDAxios,

    getPurchaseOrderDocumentList,
    deletePurchaseOrderDocument,
    uploadPurchaseOrderMultipleDocuments,
    uploadPurchaseOrderDocument,
    downloadPurchaseOrderDocument
} from "./services";

export async function getPurchaseOrdersListAction({ commit }) {
    commit(types.LOADING_PURCHASEORDERS, true);
    try {
        const { data } = await getPurchaseOrderListAxios();
        commit(types.GET_PURCHASEORDERS_LIST, data.result.data);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_PURCHASEORDERS, false);
    }
}

export async function removePurchaseOrdersAction({ commit }, payload) {
    commit(types.LOADING_PURCHASEORDERS, true);
    try {
        await deletePurchaseOrdersAxios(payload);
        commit(types.REMOVE_PURCHASEORDERS, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_PURCHASEORDERS, false);
    }
}

export async function addPurchaseOrdersAction({ commit }, payload) {
    commit(types.LOADING_PURCHASEORDERS, true);
    try {
        await postPurchaseOrdersAxios(payload);
        commit(types.ADD_PURCHASEORDERS, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_PURCHASEORDERS, false);
    }
}

export async function updatePurchaseOrdersAction({ commit }, payload) {
    commit(types.LOADING_PURCHASEORDERS, true);
    try {
        await putPurchaseOrdersAxios(payload);
        commit(types.UPDATE_PURCHASEORDERS, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_PURCHASEORDERS, false);
    }
}

export async function getPurchaseOrdersByIDAction({ commit }, payload) {
    commit(types.LOADING_PURCHASEORDERS, true);
    try {
        // await getSalesOrdersByIDAxios(payload);
        // commit(types.GET_SALESORDERSBYID, payload);
        const { data } = await getPurchaseOrdersByIDAxios(payload);
        commit(types.GET_PURCHASEORDERSBYID, data.result);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_PURCHASEORDERS, false);
    }
}

export async function getPurchaseOrderDocumentListAction({ commit },id) {
    commit(types.LOADING_PURCHASE_ORDER_DOCUMENT, true);
    try {
        const { data } = await getPurchaseOrderDocumentList(id);
        commit(types.GET_PURCHASE_ORDER_DOCUMENT_LIST, data.data);
    }
    catch (e) {
        throw e;
    }
    finally {

        commit(types.LOADING_PURCHASE_ORDER_DOCUMENT, false);
    }
}

export async function removePurchaseOrderDocumentAction({ commit }, payload) {
    commit(types.LOADING_PURCHASE_ORDER_DOCUMENT, true);
    try {
        await deletePurchaseOrderDocument(payload);
        commit(types.REMOVE_PURCHASE_ORDER_DOCUMENT, payload);
    }
    catch (e) {

        throw e;
    }
    finally {
        commit(types.LOADING_PURCHASE_ORDER_DOCUMENT, false);
    }
}

export async function downloadPurchaseOrderDocumentAction({ commit }, payload) {
    commit(types.LOADING_PURCHASE_ORDER_DOCUMENT, true);
    try {
        await downloadPurchaseOrderDocument(payload);
        commit(types.DOWNLOAD_PURCHASE_ORDER_DOCUMENT, payload);
    }
    catch (e) {

        throw e;
    }
    finally {
        commit(types.LOADING_PURCHASE_ORDER_DOCUMENT, false);
    }
}


export async function uploadPurchaseOrderDocumentAction({ commit }, {payload, referenceId = null, type = null, typeId = null}) {
    commit(types.LOADING_PURCHASE_ORDER_DOCUMENT, true);
    try {
        await uploadPurchaseOrderDocument(payload, referenceId, type, typeId);
        commit(types.ADD_PURCHASE_ORDER_DOCUMENT, payload);
    }
    catch (e) {

        throw e;
    }
    finally {
        commit(types.LOADING_PURCHASE_ORDER_DOCUMENT, false);
    }
}


export async function uploadPurchaseOrderMultipleDocumentAction({ commit }, {payload, referenceId = null, type = null, typeId = null}) {
    commit(types.LOADING_PURCHASE_ORDER_DOCUMENT, true);
    try {
        await uploadPurchaseOrderMultipleDocuments(payload, referenceId, type, typeId);
        commit(types.ADD_PURCHASE_ORDER_MULTI_DOCUMENT, payload);
    }
    catch (e) {

        throw e;
    }
    finally {
        commit(types.LOADING_PURCHASE_ORDER_DOCUMENT, false);
    }
}
